import { Box } from '../Box';
import { useProductCardContext } from './ProductCardContext';
import { useProductPrice } from '@/src/packages/hooks/use-product-price';

export const ProductCardPrice = () => {
  const {
    productVariant: {
      product: { priceList },
    },
  } = useProductCardContext();

  const prices = useProductPrice(priceList);

  return (
    <Box className="leading-none" fontFamily="sans" color="weak">
      {prices?.priceGrossFormatted}
    </Box>
  );
};
